const animalTypes = ['all', 'dog', 'cat'] as const;
const animalTypesMap: Record<(typeof animalTypes)[number], string> = {
  all: 'Все',
  dog: 'Собаки',
  cat: 'Кошки'
};

export type AnimalType = typeof animalTypes;
export { animalTypesMap, animalTypes };
